import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, Sanitizer} from '@angular/core';
import { ActivatedRoute, Router,RouterEvent,NavigationStart,NavigationError,NavigationEnd,NavigationCancel } from '@angular/router';
import { HTTPService } from './services/http.service';
import { Subscription, filter } from 'rxjs';
import { UserAuthenticationServices } from './services/user-authentication.services';
import { PrintScreenAlertService } from './system-utils/print-screen-alert/print-screen-alert.component';
import { LanguageServices } from './services/LanguageServices';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
 
  public loading:Boolean = false;
  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  //private router: Router = Inject(Router);

  constructor( private router: Router,
    private http:HTTPService,
    private activatedRoute:ActivatedRoute,
    public ps:PrintScreenAlertService,
    private ls:LanguageServices
   ){

    // Dispara o dicionario JA no bootstrap (antes era so no system-view-new,
    // ou seja, apenas depois do login): assim as telas pre-login — /changepassword
    // com senha expirada, MFA — abrem com os rotulos traduzidos, vindos do
    // bundle/cache. Ao autenticar, o loader troca pelo MKTPLANGUAGE.
    this.ls.setDefaultLanguage();

    document.addEventListener('keyup', (e) => {
      if (e.key === 'PrintScreen') {
        navigator.clipboard.writeText('');
        this.ps.showAlert = true;
      }
    });

    this.router.events.pipe(
      filter((e: any | RouterEvent): e is RouterEvent => e instanceof RouterEvent)
    ).subscribe((e: RouterEvent) => {
      this.checkRouterEvent(e);
    });
    
    this.sub2 = this.http.event.subscribe( (event:Event) => {
      this.checkHttpEvent(event)
    },(error)=>{
      setTimeout(() => this.loading = false);
    });      

  }

  async ngOnInit(): Promise<void> {
    // MatIconRegistry removido: os icones agora sao servidos pelo NzIconService
    // (registro dos SVGs customizados em UserAuthenticationServices.loadSvgs).
  }

  ngOnDestroy(){
     if ( this.sub != null){ this.sub.unsubscribe(); }
     if ( this.sub2 != null){ this.sub2.unsubscribe(); }
     if ( this.sub3 != null){ this.sub3.unsubscribe();}
  }

  checkHttpEvent(event:Event){
      if ( event.type == "startPost"){
        setTimeout(() => this.loading = true);
      }else{
        setTimeout(() => this.loading = false);
      }
  }

  checkRouterEvent( routerEvent:RouterEvent){
      if (routerEvent instanceof NavigationStart ){
        this.loading  = true;
      }
      
      if ( routerEvent instanceof NavigationError ||
           routerEvent instanceof NavigationEnd ||
           routerEvent instanceof NavigationCancel){
             this.loading = false;
      }

  }

  ngAfterViewInit() {
    //this.cd.detach()
  }
  
}
